<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <img src="/static/images/trash-big.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px" v-if="auction_list.length == 1">
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Delete Auction</div>
                    Do you want to delete selected Auction ?
                </div>
                <div class="mt-5" style="font-size: 16px" v-else>
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Delete Auctions</div>
                    Do you want to delete selected Auctions ?
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-no-button mr-4 px-4" @click="hideSelf">No</button>
                    <button class="btn new-yes-button ml-4 px-4" @click="confirmDelete">Yes</button>
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn btn-des-small mr-4 px-4" style="background: transparent; color: #0d5be6; border: 1px solid transparent; width: 4em" disabled>No</button>
                    <button class="btn btn-des-small ml-4 px-4" style="background: #005dae; color: #fff; border: 1px solid transparent; width: 4em;position: relative" disabled>Yes
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name","auction_form_selected"],
    data() {
        return{
            disableButtonAndDisplayLoader: false,
            auction_list: [],
        }
    },
    components: {
        HollowDotsSpinner,
    },
    methods: {
        hideSelf() {
            this.$emit("cancelDelete");
            this.$modal.hide(this.modal_name);
        },
        confirmDelete() {
            this.disableButtonAndDisplayLoader = true;
            this.$emit("deleteAuctions");
            setTimeout(() => {
                this.disableButtonAndDisplayLoader = false;
            }, 1500);
        }
    },
    mounted(){
        this.auction_list = this.auction_form_selected;
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Auction/DeleteAuction.vue